import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { PetitionTypes } from '../../models/petition-types';
import { CoefficientProvider } from '../../providers/coefficient/coefficient';
import { PetitionProvider } from '../../providers/petition/petition';


@IonicPage()
@Component({
  selector: 'page-petition-extra-hours',
  templateUrl: 'petition-extra-hours.html',
})
export class PetitionExtraHoursPage {

  petition: any = {};

  coefficients;
  coefficientsSubscription;

  maxPeriod: number;
  minPeriod: number;

  constructor(
    private loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public petitionProvider: PetitionProvider,
    public coefficientProvider: CoefficientProvider,
    public globalVars: GlobalVars,
  ) {
    this.maxPeriod = this.globalVars.currentPeriod + 1;
    this.minPeriod = this.globalVars.currentPeriod - 1;
    
    this.coefficientsSubscription = coefficientProvider.getAll().subscribe(coefficients => {
      this.coefficients = coefficients;
      console.log(this.coefficients)
    })
  }

  ngOnDestroy() {
    this.coefficientsSubscription.unsubscribe();
  }

  calculateTotalHours() {
    if (this.petition.quantity && this.petition.coefficient) {
      let coeff = this.coefficients.filter(coeff => coeff.key == this.petition.coefficient)[0];

      this.petition.totalHours = this.petition.quantity * coeff.ratio;
    }

    else if (!((this.petition.quantity && this.petition.coefficient))) this.petition.totalHours = null;
    else this.petition.totalHours = 0;
  }

  send() {
    if (this.checkData()) {
      this.petition.user = this.globalVars.user.name;
      this.petition.userKey = this.globalVars.user.key;
      this.petition.type = 'Horas extra';
      this.petition.typeId = PetitionTypes.extraHours;
      this.petition.comments = this.petition.comments ? this.petition.comments : ' ';
      this.petition.area = this.globalVars.user.area;
      this.petition.areaId = this.globalVars.user.areaId;
      this.petition.state = this.globalVars.user.areaId;
      this.petition.stateName = this.globalVars.user.area;
      this.petition.annulment = false;
      this.petition.annulmentSended = false;
      this.petition.creationDate = new Date().getTime();
      this.petition.mailbox = false;
      this.petition.process = 'flow';
      this.petition.coefficientName = this.coefficients.filter(coefficient => coefficient.key == this.petition.coefficient)[0].name;
      
      console.log(this.petition)

      let loading = this.loadingCtrl.create();
      loading.present()

      this.petitionProvider.addPetition(this.petition)
      .then(msg => {
        loading.dismiss()
        this.showMessage(msg)
        this.navCtrl.pop();
      })
      
      .catch(error => {
        loading.dismiss()
        this.showMessage(error)
      })
    }

    else this.showMessage(`Introduzca todos los datos.`);
  }

  private checkData() {
    if (this.petition.date && this.petition.quantity && this.petition.coefficient
      && this.petition.totalHours && this.petition.comments) return true;

    return false;
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/petition-extra-hours/petition-extra-hours.ts